/* eslint-disable no-undef */

export default {
	name: "modal-table",
	props: ["heading", "modalId", "showModal", "headings", "data", "hasActions", "hasCustomActionComponent", "hasNoFilter", "pagingDetails", "hasNoPaging", "stateChanged"],
	emits: ["okClicked", "filterSearchClicked", "onActionClicked", "pagingUpdated"],
	data() {
		return {
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			searchQuery: null
		};
	},
	methods: {
		onModalCloseClick() {
			this.$emit("okClicked", true);
		},
		onFilterSearchClicked(){
			this.$emit("filterSearchClicked", this.searchQuery);
		},
		onActionClicked(actionAndData){
			this.$emit("onActionClicked", actionAndData);
		},
		onPagingUpdated(pagingInfo){
			this.$emit("pagingUpdated", pagingInfo);
		},
	},
	mounted: function () {
        
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		isSaving: {
			handler: function () {
				if(this.isSaving !== null && this.isSaving !== undefined){
					this.formIsSaving = this.isSaving;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal({backdrop: 'static', keyboard: false});
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};
